export const oaBaseFilter = [
	{ key: "business_id", label: "Razón Social", type: "select", value: "", visible: true, placeholder: "Razón Social", options: [], multiple: false },
	{ key: "status", label: "Estado", type: "select", value: "", visible: true, placeholder: "Estado", options: [], multiple: true },
	{ key: "type", label: "Tipo", type: "select", value: "", visible: true, placeholder: "Tipo", options: [], multiple: true },
	{ key: "internal_code", label: "Cód. Interno", type: "text", value: "", visible: false, placeholder: "Buscar por código interno" },
	{ key: "season_id", label: "Temporada", type: "select", value: "", visible: true, placeholder: "Temporada", options: [] },
	{ key: "date_start", label: "Fecha Desde", type: "date", value: "", visible: true, placeholder: "Fecha desde" },
	{ key: "date_end", label: "Fecha Hasta", type: "date", value: "", visible: true, placeholder: "Fecha hasta" },
	{ key: "compliance_from", label: "% Cumplimiento Desde", type: "number", value: "", visible: true, placeholder: "Ej: 0" },
	{ key: "compliance_to", label: "% Cumplimiento Hasta", type: "number", value: "", visible: true, placeholder: "Ej: 90" },
];

export const oaBaseTable = {
	page: 1,
	per_page: 20,
	order_by: "code",
	order_dir: "desc",
};
